import React from "react";
import { Button, NumberInput, ReferenceInput, required, SelectInput, TextInput, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";

const EditIndividualExamDialog = ({ individualExamId, fetchDisciplineData }) => {
  const notify = useNotify();

  const handleConfirm = async values => {
    const { examName, type, grade } = values;
    const payload = {
      examName,
      type,
      grade,
    };

    await dataProvider.customRequest(studentRequests.updateIndividualExam(individualExamId), payload, "PUT");
    notify("Успешно редактиране на индивидуален изпит", { type: "success" });
    fetchDisciplineData();
  };

  return (
    <FormModal
      titleContent="Редактирай оценка"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Редактирай"
          startIcon={<EditIcon />}
          variant="contained"
        />
      }
    >
      <Grid
        container
        columnSpacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="examName"
            label="Име на изпит"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="type"
            reference={studentRequests.getIndividualExamsTypesSelect()}
          >
            <SelectInput
              optionText="name"
              label="Тип изпит"
              emptyText={false}
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <NumberInput
            source="grade"
            label="Оценка"
            min={2}
            max={6}
            step={0.01}
            validate={required()}
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default EditIndividualExamDialog;
